/*
グローバルミックスイン
[概要]
サイト全体で使用するメソッドなどを定義する
[詳細]
[使い方]
main.jsで、mixin使用を宣言して使用
[特記]
main.jsで別に宣言定義しているもをまとめるように
*/

/*拡大表示用コンポーネント*/
import Vue from 'vue'
import OverView from '@/components/OverView.vue'

/*smoothScroll終了監視使用*/
let scrollResolveTimeout

export default {
  name:'globalUse',
  data: function(){
        return {
					scrollResolveTimeout,
        }
  },
  computed: {
		isUrl:function() {
			return window.location.href
		},
		isTitle:function() {
			return this.$route.name
		},
	},
	components:{
		OverView,
	},
  methods: {
/*
ページ内スムーススクロール
[概要]
タグジャンプスムーススクロール
[詳細]
whereTo：飛び先ID（#なしで）
[特記]
*/
    smoothScroll:function(whereTo) {
			if( document.getElementById(whereTo) != null ) {
				document.getElementById(whereTo).scrollIntoView({behavior:"smooth"})
			}
    },

/*
ページ内スムーススクロール 終了監視付き
[概要]
タグジャンプスムーススクロール
[詳細]
whereTo：飛び先ID（#なしで）
[特記]
他のスクロール処理と干渉し合わないように
store管理変数：scrollStatusにスクロール状態を保持する。
他スクロール処理側では、状態を監視して処理する
*/
    smoothScroll2:function(whereTo, e, offset) {
//console.log(offset)
			let aObject = document.getElementById(whereTo)
			if( aObject != null ) {
				this.$store.dispatch('scrollStatusAsync', 'START')
				let promise = new Promise((resolve) => {
if(offset !== undefined) {
this.scrollIntoViewWithOffset(whereTo, offset)
 }else {
					aObject.scrollIntoView({behavior:"smooth"})
}
					let aWait = this.waitForScrollComplete()
					.then(() => {
						this.$store.dispatch('scrollStatusAsync', '')
						scrollBy(0,1)  //scrollイベントを発生させる
						e.target.blur()
					})
				})
			} else {
//console.log("未完成")
			}
    },

		scrollIntoViewWithOffset:function(selector, offset) {
			window.scroll({
				behavior: 'smooth',
				top: offset,
/*
					document.getElementById(selector).getBoundingClientRect().top -
					document.body.getBoundingClientRect().top -
					offset,
*/
			})
		},

/*
スクロール 終了監視
[概要]
スクロール状態を通知する
[詳細]
whereTo：飛び先ID（#なしで）
[特記]
他のスクロール処理と干渉し合わないように
store管理変数：scrollStatusにスクロール状態を保持する。
他スクロール処理側では、状態を監視して処理する
*/
		waitForScrollComplete:function() {
			return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
					resolve(true)
				}, 100)
				const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
					clearTimeout(scrollTimeout)
					clearTimeout(this.scrollResolveTimeout)
					this.scrollResolveTimeout = setTimeout(function () {
						removeEventListener('scroll', fn)
						resolve(true)
					}, 100)
				})
			})
		},

/*
別ページからのページ＆タグ遷移
[概要]
[詳細]
タグジャンプが必要な移動ページ側のmountedに設定する
[特記]
*/
		changePageScrollAnchor() {
//			document.getElementById("app").scrollIntoView()

			this.hash = this.$route.hash
			this.$nextTick(function () {
				if (this.hash) {
					const refName = this.hash.replace('#', '')
	
					let aTimerID = setTimeout(() => { //タイミングとして画像配置分読み込みが不正確になるため、発動を遅らせる
console.log("SCROLL")
						this.smoothScroll(refName)
					}, 200)
				}
			})
		},

/*
別ページからのページ＆タグ遷移
[概要]
タグ指定する
[詳細]
タグジャンプが必要な移動ページ側のmountedに設定する
[特記]
*/
		changePageScrollAnyAnchor(aHash) {
			this.$nextTick(function () {
				if (aHash) {
					const refName = aHash
	
					let aTimerID = setTimeout(() => { //タイミングとして画像配置分読み込みが不正確になるため、発動を遅らせる
						this.smoothScroll(refName)
					}, 100)
				}
			})
		},


/*
[概要]
[詳細]
[特記]
*/
    scrollForHeight:function() {
      window.scrollBy(0, window.innerHeight)
    },

/*
スクロールアニメーション
[概要]
自身イメージをスクロール動作に伴い動かす
[詳細]
対象タグに直接セットする v-scroll="handleScrollSelf"
*/
    handleScrollSelf:function (evt, el) {
			this.handleScroll(evt, el, "self")
		},

/*
スクロールアニメーション
[概要]
子に配置したイメージをスクロール動作に伴い動かす
[詳細]
アニメーション対象タグの親要素にセットする v-scroll="handleScrollChild"
*/
    handleScrollChild:function (evt, el) {
			this.handleScroll(evt, el, "child")
		},

/*
スクロールアニメーション
[詳細]
・イメージをスクロール動作に伴い動かす
・START監視付き
（通常のスクロールとタグジャンプでのスクロールを監視し、アニメーションを制御する）
[使い方]
ディレクティブv-scrollで使用。return false：監視中、true：終了（リスナーから外す）
[特記]
handleScrollSelfは動作するオブジェクト自体にセット。
handleScrollChildは動作するオブジェクトの親にセット。
*/
    handleScroll:function (evt, el, target) {
      let res = false
      let adjustment = 0
      const rect = el.getBoundingClientRect()
			let aOffsetTop = rect.top
			let aOffsetBottom = rect.bottom
			let aTargetObject = (target == "self")?el:el.firstChild

//表示エリアサイズで
      let windowWidth = document.documentElement.clientWidth
			if(windowWidth > 991) {
				adjustment = window.innerHeight/5*4
			} else {
				adjustment = window.innerHeight/5*4
			}

//指定範囲内での状態監視 scrollStatus
//カラ、指定文字以外：アニメーションセット
//状態識別子；自動スクロール中のため、停止後アニメーションをセットする
      if(aOffsetTop < adjustment && 100 < aOffsetBottom) {
				switch(this.$store.state.scrollStatus) {
				case "START":
					this.$store.dispatch('scrollStatusAsync', 'SCROLL')
					break;
				case "SCROLL":
					break;
				case "SCROLLED":
					this.$store.dispatch('scrollStatusAsync', '')
					break;
				default:
	        if(aTargetObject.classList.contains('fromLeft')) {
						aTargetObject.classList.add('animeFromLeft');
					} else if(aTargetObject.classList.contains('fromRight')) {
						aTargetObject.classList.add('animeFromRight')
					} else if(aTargetObject.classList.contains('fromBottom')) {
						aTargetObject.classList.add('animeFromBottomRecruit')
					} else if(aTargetObject.classList.contains('fromTop')) {
						aTargetObject.classList.add('animeFromTop')
					} else if(aTargetObject.classList.contains('fromCenter')) {
						aTargetObject.classList.add('animeFromCenter')
					} else if(aTargetObject.classList.contains('fadeIn')) {
						aTargetObject.classList.add('animeFadeIn')
					} else if(aTargetObject.classList.contains('yAxis')) {
						aTargetObject.classList.add('animeYAxis')
					} else if(aTargetObject.classList.contains('zAxisLoop')) {
						aTargetObject.classList.add('animeZAxisLoop')
					} else if(aTargetObject.classList.contains('zAxisStepLoop')) {
						aTargetObject.classList.add('animeZAxisStepLoop')
					} else if(aTargetObject.classList.contains('bounceFromTop')) {
						aTargetObject.classList.add('animeBounceFromTop')
					} else if(aTargetObject.classList.contains('moveIn')) {
						aTargetObject.classList.add('animeMoveIn')
					} else if(aTargetObject.classList.contains('moveInText')) {
						aTargetObject.classList.add('animeMoveInText')
					}
	        res = true	
				}
			}
      return res
    },

/*
ISO日付データを[年月日]で表示出力する
[概要]
jsonデータの情報有無を確認
[詳細]
*/
		isoDateToDisplayDate(isoDate) {
			let aDate = new Date(isoDate)
			return aDate.toLocaleString('ja-JP',{timeZone: 'Asia/Tokyo', year:"numeric", month:"numeric", day:"numeric"})
		},
/*
ISO日付データを[年月]で表示出力する
[概要]
jsonデータの情報有無を確認
[詳細]
*/
		isoDateToDisplayDateMonth(isoDate) {
			let aDate = new Date(isoDate)
			return aDate.toLocaleString('ja-JP',{timeZone: 'Asia/Tokyo', year:"numeric", month:"numeric"})
		},

/*
ISO日付データか否かを判断する
[概要]
[詳細]
	true:ISO日付データ
	false:ISO日付データでない
*/
		isInvalidDate(aDate) {
			return !Number.isNaN(aDate.getTime())
		},

/*
ページ遷移
[概要]
jsonデータのリンク指定情報から、内部リンク、外部リンクを判断しページ遷移を行う
[詳細]
url：url or ページ名+アンカー
flg：in  ->内部リンク
			 out ->外部リンク
[特記]
urlの設定内容で、外部/内部リンク判別に変更。flg未使用にする
*/
		toAnyPage(url, flg) {
//			if(flg == "out") {
			if( url.indexOf("http") !== -1 ) {
				window.open(url, '_blank')
			} else {
				let aPos = url.indexOf("#")
				let aPage = url
				let aHash = ""
				if((aPos) !== -1) {
					aPage = "/"+ url.slice(0,aPos)
					aHash = url.slice(aPos+1)
				} else {
					aPage = "/" +  url
				}
				this.$router.push({
					path: aPage,
					hash: aHash,
				})
			}
		},

/*
ハイパーリンク有無判断
[概要]
jsonデータの情報有無を確認
[詳細]
*/
    isAnyLink:function(url) {
			return (url === null)? false:true
    },

/*
リンクアイコン&アニメーションセット
[概要]
外部リンクの場合："externalLink" classセット
内部リンクの場合："pageLink" classセット
[詳細]
@mouseenter="addLinkIcon(j.link, $event)" 
*/
		addLinkIcon:function(url, event) {
			if( url.indexOf("http") !== -1 ) {
				event.target.classList.add("externalLink")  //外部リンク
			} else if(url !== null){
				event.target.classList.add("pageLink")  //内部リンク
			} else {
//未セット
			}
    },
/*
リンクアイコン&アニメーション削除
[概要]
外部リンク"externalLink" class、内部リンク"pageLink" classを削除する。
[詳細]
 @mouseleave="deleteLinkIcon" 
*/
		deleteLinkIcon:function(event) {
			event.target.classList.remove("externalLink")
			event.target.classList.remove("pageLink")
		},

/*
vue-headモジュール情報更新
[概要]
[詳細]
*/
		updateHead() {
			this.$emit('updateHead')
		},

/*
ページ階層チェック
[概要]
childrenページが表示されているかをチェックする
[詳細]
true：子ぺーじ
false：親ページ
*/
		checkHierarchy() {
			let aCheckDirectory = this.$options.name + "/"
			return this.$route.path.includes(aCheckDirectory)
		},

/*
ページ毎にタグジャンプ用に情報を収集する
[概要]
class="tagJumpTarget"をセットしたエレメントのIDとタイトル名を収集する
[詳細]
mounted, updatedで$store：pageSectionInfoに情報をセットして、innerNav.vueに情報を渡す

aBlock:true タイトルではなく、ブロック全体のTOPを取得する

不具合：スクロール途中状態で要求が発生した場合に、rect値が現在スクロール位置を基点とするためこれを補正しなければならない。

*/
    gatherTagId:function(aBlock){
      var arr = []
      var title, id, rect, targetObject, kind

			let aScrollPos = 0    //現在のスクロール位置
			let aAdjustTop = -70  //頭出しの位置調整

//収集前にスクロール状態をリセットしたい
			if(!aBlock) {
				document.getElementById("app").scrollIntoView()
			}
			aScrollPos = window.scrollY

      var innerNavObjectList = document.getElementsByClassName('tagJumpTarget')
      for(var i of innerNavObjectList) {
/*
        if( i.getElementsByTagName('h1').length ) {
          kind = "h1"
          targetObject = i.getElementsByTagName('h1')[0]
          rect = targetObject.getBoundingClientRect()
        } else if( i.getElementsByTagName('h2').length ) {
*/
				if( i.getElementsByTagName('h2').length ) {
          kind = "h2"
					title = i.getElementsByTagName('h2')[0].innerText
					if(aBlock) {
						targetObject = i
					} else {
						targetObject = i.getElementsByTagName('h2')[0]
					}
					rect = targetObject.getBoundingClientRect()
        } else if( i.getElementsByTagName('h3').length ) {
          kind = "h3"
					title = i.getElementsByTagName('h3')[0].innerText
					if(aBlock) {
						targetObject = i
					} else {
						targetObject = i.getElementsByTagName('h3')[0]
					}
					rect = targetObject.getBoundingClientRect()
        } else {
          kind = "h4"
					title = i.getElementsByTagName('h4')[0].innerText
					if(aBlock) {
						targetObject = i
					} else {
						targetObject = i.getElementsByTagName('h4')[0]
					}
					rect = targetObject.getBoundingClientRect()
        }

/*親子ページの場合：親の要素は組み込まないようにする*/
        if(rect.height > 0 ) {
          id = i.id

//rect値をscroll状態を加味して反映する
					var aRect = DOMRect.fromRect(rect)
					aRect.x = aRect.x
					aRect.y = aRect.y + aScrollPos + aAdjustTop
          arr.push({"title":title, "id":id, "rect":aRect, "kind":kind})
        }
      }
//console.log(arr)
      return arr
    },

/*
ページ内容表示判断用
[概要]
子を持つ親コンポーネントの内容の表示/非表示
[詳細]
エレメントにv-show="checkHideContents(定数)"をセットし表示/非表示を制御する
親自身表示 > true
子を表示中 > false
*/
    checkHideContents:function(aLayer) {
//対象となるオブジェクトを引っ張ってこないと
      return (this.$route.matched.length === aLayer)?true:false
    },

/*
変数型変換
[概要]
observeをArrayにする
[詳細]
*/
    observeToArray(aObserveObject) {
      let jsonString = JSON.stringify(aObserveObject)
      return JSON.parse(jsonString) 
    },
/*
イメージ拡大
[概要]
[詳細]
OverView.vueコンポーネントを使用しイメージ拡大表示する
*/
    openOverView:function(event, valid) {
			if(valid === false ) {
				return
			}
/*
      let targetUrl = event.target.getAttribute('src')
//拡大画像については、dataset.imageがある場合は、こちらを表示するように
      if(event.target.dataset.image != "") {
        targetUrl = event.target.dataset.image
      }
      let targetAlt = event.target.getAttribute('alt')
*/

			let targetUrl = event.target.getAttribute('src')
      let targetAlt = event.target.getAttribute('alt')
			let aFullImage = event.target.dataset.image
			if(aFullImage == "")  {
				return
			} else if(aFullImage != null) {
					targetUrl = aFullImage
			}

      let element = document.querySelector('main')
      let addComponent = Vue.extend(OverView)
      let instance = new addComponent({propsData:{imageUrl:targetUrl,imageAlt:targetAlt}})
      instance.$mount()
      element.append(instance.$el)
    },

/*
ブラウザーサイズチェック
[概要]
ブラウザーサイズをチェックする
[詳細]
true:PCサイズ対応
false:タブレット、スマホサイズ対応
*/
    checkWidthSize:function(event, from) {
      let windowWidth = document.documentElement.clientWidth  //表示エリアサイズで
			return (windowWidth > 991)?true:false
		},


/*
ツールチップ表示処理
[概要]
ツールチップを表示する
アクセシビリティ規約（Tabキー処理風む）対応
・tooltip表示時は、マウスがtooltip上にいる場合も表示し続ける
・tabキー選択でフォーカスされた時にtooltipは表示する
・フォーカス時はescキーでtooptipOFFにする
[詳細]
リンクがない場合：
<p class="flagTip"><a href="javascript:void(0);" class="forTip" @mouseenter="openTip" @mouseleave="closeTip" @focus="openTip" @blue="closeTip" @keyup.esc="closeTip" aria-describedby="">説明が必要な文章<span class="tip" role="tooltip">* 説明文章 or イメージ</span></a></p>

リンクを含む場合：
<p class="flagTip"><router-link to="/customer/contact" class="forTip" @mouseenter.native="openTip" @mouseleave.native="closeTip" @focus.native="openTip" @blue.native="closeTip" @keyup.esc.native="closeTip" aria-describedby="">説明が必要な文章<span class="tip" role="tooltip">* 説明文章 or イメージ</span></router-link></p>

[不具合01]
スマホで、focusとmousenter（<別イベント）とがともに発動する。
ともに単体では正常に反応するため、多重になった場合におかしくなる。
*/
		openTip:function(event) {
//console.log("OPENTIP")
			event.target.classList.add("toolTip")

//基準object 起点に
//表示位置で起点を変える
//bottom,left
//bottom,right
//top,left
//top,right
			let aBaseObjectRect = event.target.getBoundingClientRect()
			let aBaseObjectTop = aBaseObjectRect.top
			let aBaseObjectBottom = aBaseObjectRect.bottom
			let aBaseObjectLeft = aBaseObjectRect.left
			let aBaseObjectRight = aBaseObjectRect.right
			let aBaseObjectWidth = aBaseObjectRect.width
			let aBaseObjectHeight = aBaseObjectRect.height

//tip
			let aTipObject = event.target.querySelector('span.tip')

//不具合01対応
// 対象にすでにtoolTipContentが付加されている場合は、以下処理を行わない
			if(aTipObject.classList.contains("toolTipContent")) {
//何もせずに終了する
				return
			}

			aTipObject.classList.add("toolTipContent")
			let aObjectRect = aTipObject.getBoundingClientRect()
			let aObjectWidth = aObjectRect.width
			let aObjectHeight = aObjectRect.height

//view
			let aWindowRight = window.innerWidth
			let aWindowBottom = document.documentElement.clientHeight
			let aWindowLeft = 0

//console.log("BASE",aBaseObjectRect)
//console.log("TIPS",aObjectRect)
//console.log("WINDOW W", aWindowRight)			//aRectRight
//console.log("WINDOW H", aWindowBottom)  //aRect.bottom

//左右判定
document.documentElement.style.setProperty('--tipWidth', (aObjectWidth + 'px'))

	//PCの場合、左右の配置状態で表示基点の表示向きを変えて表示する
			let aWindowWidth = document.documentElement.clientWidth

	if(aWindowWidth > 991) {
			if(aBaseObjectLeft + aObjectWidth < aWindowRight ) {
//left起点表示
//console.log("LEFT", aBaseObjectLeft, aObjectWidth, aWindowRight)
				aTipObject.classList.add("toolTipContentLeft")
			} else {
//right起点表示
//console.log("RIGHT", aBaseObjectRight, aObjectWidth, aWindowLeft)
				aTipObject.classList.add("toolTipContentRight")
			}
	} else {
//console.log("SMART")
	//スマホの場合、width300px 中央表示に固定
		let aOverSize = (aObjectRect.left - (aWindowWidth - 300)/2) * -1
		let aCorrectSize = (aWindowWidth - 300)/2 + aOverSize
document.documentElement.style.setProperty('--tipCorrection', (aOverSize + 'px' ))
//console.log("CENTER", aObjectRect, aWindowWidth)
		aTipObject.classList.add("toolTipContentCenter")
	}

//上下判定
document.documentElement.style.setProperty('--tipHeight', ('-' + aObjectHeight + 'px' ))

			if(aBaseObjectBottom + aObjectHeight < aWindowBottom ) {
//bottom起点表示
//console.log("BOTTOM")
				aTipObject.classList.add("toolTipContentBottom")
			} else {
//top起点表示
//console.log("TOP")
				aTipObject.classList.add("toolTipContentTop")
			}
		},
		closeTip:function(event) {
//console.log("CLOSE", event.target.style)
			event.target.classList.remove("toolTip")
			let aTipObject = event.target.querySelector('span.tip')
aTipObject.classList.remove("toolTipContentLeft","toolTipContentRight","toolTipContentTop","toolTipContentBottom", "toolTipContentCenter")
			aTipObject.classList.remove("toolTipContent")
		},
/*
改行変換処理
[概要]
指定文字列の'\n'を<br>に変換する
[詳細]
*/
		replaceBr:function(aStr) {
//console.log(aStr)
			 return aStr.replace(/\n/g, '<br>')
		},
/*
テキスト表示数制限処理
[概要]
指定文字列が80文字を超えた場合には、3点リードをつけて80文字表示とする
[詳細]
*/
		limitedTextDisplay(text) {
			let aContinue = "..."
			if(text.length < 80 ) {
				aContinue = ""
			}
			return text.slice(0, 80) + aContinue
		},
/*
セパレータースペース処理
[概要]
スペースセパレーターの文字列を配列で返す
[詳細]
*/
  	spaceSeparator: function(aString) {
			return aString.split(' ')
		},

/*
パンくず構造化データ生成処理
[概要]
各ページ毎のパンくず構造化データを生成する
[詳細]
*/

		makeBreadcrumbList:function() {
			let aStructuredText = '[{"@context": "http://schema.org","@type": "BreadcrumbList","itemListElement": ['
			let aItemListItem = []
			let aStructuredListItem = {
				"@type": "ListItem",
				"position": 1,
				"name": "home",
				"item": ""
			}
			let aScheme = window.location.protocol
			let aDomain = window.location.hostname
			let aAddress = this.$route.path
			let aPageNameArray = [""]
			if(aAddress != '/') {
				aPageNameArray = aAddress.split("/")
			}
			let i = 0
			for( ; i<aPageNameArray.length; i++) {
				aStructuredListItem["position"] = i+1
				if(i==0) {
					aStructuredListItem["name"] = "home"
					aStructuredListItem["item"] = aScheme + "//" + aDomain
				} else {
					aStructuredListItem["item"] = aStructuredListItem["item"] + "/" + aPageNameArray[i]
//router.jsからname情報を取得する
					let o = this.$route.matched
					if(o[i-1].path.indexOf(':') > -1) {
						aStructuredListItem["name"] = decodeURI(aPageNameArray[i])
					} else {
						aStructuredListItem["name"] = o[i-1].name
					}
				}
				aStructuredText += JSON.stringify(aStructuredListItem) + ","
			}
			return aStructuredText.slice( 0, -1 ) +"]}]"
		},

/*
デバッグ用コンソール出力
[概要]
コンソール出力を一括管理し、出力を管理する
[詳細]
*/
    _log(...aArgs) {
			let aString = ''
			for (const arg of aArgs) {
				aString += arg
			}
//			console.log(aString)
    },
  }
}